export const getSafeReturnTo = (search, fallback = '/dashboard') => {
  const params = new URLSearchParams(search);
  const returnTo = params.get('returnTo');

  if (!returnTo) {
    return fallback;
  }

  if (returnTo.startsWith('/') && !returnTo.startsWith('//')) {
    return returnTo;
  }

  return fallback;
};